import React, { useEffect ,useState} from "react";
import { UseHrApp } from "../../utils/context";
import { FaUserTimes } from "react-icons/fa";
import { AiOutlineEye } from "react-icons/ai";
import axios from "axios";
import PositionedSnackbar from "../snackbar";
import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import DeleteModal from "./ConfirmDeleteModal";
import { CircularProgress } from "@mui/material";

export default function TableLg() {
  const {
    employees,
    GetEmployees,
    token,
    text,
    show,
    severity,
    settext,
    setshow,
    setseverity,
    loader
  } = UseHrApp();

  //https://hr-app-api.onrender.com/employees/left?id=

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState([]);




  const navigate = useNavigate();
  const [viewed, setViewed] = React.useState(false);

  async function GetSingleEmployee(id) {
    try {
      if (!viewed) {
        // Only make the API call if the employee details were not already viewed
        const res = await axios({
          // Use await here to wait for the API response
          url: `https://hr-app-api.onrender.com/employees/employee?id=${id}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (res?.data?.status) {
          navigate(`/admin/mainDash/employees/view?id=${id}`);
          setViewed(true); // Mark the employee details as viewed
        }
      }
    } catch (error) {
      console.log("error");
    }
  }

  useEffect(() => {
    GetEmployees();
  }, []);

  /**
   * 
       <div className=" w-[60px] h-[40px] flex justify-center items-center bg-[#9A6AFF]">
       <FaSearch/> 
        </div>
   */

        useEffect(() => {
          // Call the search function whenever searchQuery or employees list changes
          searchEmployees();
        }, [searchQuery, employees]);


        const searchEmployees = () => {
          // Filter employees based on the search query
          const filtered = employees.filter(
            (employee) =>
              employee.firstname.toLowerCase().includes(searchQuery.toLowerCase()) ||
              employee.lastname.toLowerCase().includes(searchQuery.toLowerCase())
          );
          setFilteredEmployees(filtered);
        };


  return (
    <div>
      <div className="container mx-auto hidden lg:block ">
        <div className="flex items-center">
          <div className=" my-[2em] w-[50%] h-[40px] ">
            {/* Add the search input field */}
            <input
              type="text"
              placeholder="Search employees by name..."
              className="w-full h-full p-1"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>
        {loader? (
        <div className="w-full min-h-[50vh] flex justify-center items-center">
          <CircularProgress/>
          </div>):(
        <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr>
              <th className="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                index
              </th>
              <th className="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                Firstname
              </th>
              <th className="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                Lastname{" "}
              </th>
              <th className="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                Email
              </th>
              <th className="px-6 py-3  bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                Gender
              </th>
              <th className="px-6 py-3  bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                Department
              </th>
              <th className="px-6 py-3  bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                Status
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {filteredEmployees.map((item, index) => (
              <tr key={item.id}>
                <td className="px-4 py-4 whitespace-no-wrap">{index}</td>
                <td className="px-4 py-4 whitespace-no-wrap">
                  {item.firstname}
                </td>
                <td className="px-4 py-4 whitespace-no-wrap">
                  {item.lastname}
                </td>
                <td className="px-4 py-4 whitespace-no-wrap">{item.email}</td>
                <td className="px-4 py-4 whitespace-no-wrap">{item.gender}</td>
                <td className="px-4 py-4 whitespace-no-wrap">
                  {item.department.name}
                </td>
                <td className={"px-4 py-1  whitespace-no-wrap"}>
                  <div
                    className={
                      item.status === "Active"
                        ? "h-6 text-[#32bd67] text-center  bg-[#eaedf1]  rounded-[3em]"
                        : " bg-[#f1f3f5] h-6 text-[#e2bc3e] text-center rounded-[3em]"
                    }
                  >
                    {item.status}
                  </div>
                </td>
                <td className="px-4 py-4 whitespace-no-wrap">
                  <div className=" flex gap-2">
                    <button
                      className="  w-max p-[2px] flex items-center justify-center bg-[#daeaff] "
                      onClick={() => {
                        GetSingleEmployee(item.id);
                      }}
                    >
                      <AiOutlineEye color="black" />{" "}
                    </button>
                    <DeleteModal id={item.id} firstname={item.firstname} lastname={item.lastname} />
                 
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>)}
      </div>
      <PositionedSnackbar
        value={show}
        setshow={setshow}
        text={text}
        severity={severity}
      />
    </div>
  );
}
